// Pure form helpers (no network, no storage) – covered by offline tests.
export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

const LEVELS = ["Noch kein Passwort", "Zu schwach", "Mittel", "Gut", "Stark"];

export function passwordStrength(pw) {
  const s = String(pw || "");
  if (!s) return { level: 0, label: LEVELS[0], ok: false };
  let score = 0;
  if (s.length >= 14) score++;
  if (/[a-zäöü]/.test(s) && /[A-ZÄÖÜ]/.test(s)) score++;
  if (/\d/.test(s)) score++;
  if (/[^A-Za-z0-9äöüÄÖÜß]/.test(s)) score++;
  const level = s.length < 10 ? 1 : Math.min(4, 2 + Math.floor(score / 2));
  return { level, label: LEVELS[level], ok: s.length >= 10 };
}

export function registrationErrors({ firstName, email, password, terms }) {
  const e = {};
  if (!String(firstName || "").trim()) e.firstName = "Bitte gib deinen Vornamen ein.";
  if (!isEmail(email)) e.email = "Bitte gib eine gültige E-Mail-Adresse ein.";
  if (!passwordStrength(password).ok) e.password = "Das Passwort braucht mindestens 10 Zeichen.";
  if (!terms) e.terms = "Bitte bestätige, dass du die Nutzungsregeln und Datenschutzhinweise gelesen hast.";
  return e;
}

export function newPasswordErrors(pw, repeat) {
  const e = {};
  if (!passwordStrength(pw).ok) e.password = "Das Passwort braucht mindestens 10 Zeichen.";
  if (pw !== repeat) e.repeat = "Die beiden Passwörter stimmen nicht überein.";
  return e;
}

const YEAR = 365 * 24 * 60 * 60 * 1000;

// Share (M20): exactly the chosen fields, a named recipient, a short purpose, an expiry within a year and explicit consent.
export function shareErrors({ fields, recipientId, purpose, expiresAt, consent }, now = Date.now()) {
  const e = {};
  if (!fields || fields.length === 0) e.fields = "Wähle mindestens eine gespeicherte Angabe aus.";
  if (!recipientId) e.recipient = "Wähle eine bestätigte Kontaktperson aus.";
  const p = String(purpose || "").trim();
  if (!p) e.purpose = "Gib einen konkreten Zweck an.";
  else if (Array.from(p).length > 120) e.purpose = "Der Zweck darf höchstens 120 Zeichen lang sein.";
  const t = expiresAt ? new Date(expiresAt).getTime() : NaN;
  if (!Number.isFinite(t) || t <= now) e.expires = "Wähle einen Ablaufzeitpunkt in der Zukunft.";
  else if (t - now > YEAR) e.expires = "Eine Freigabe kann höchstens ein Jahr gelten.";
  if (consent !== true) e.consent = "Bitte bestätige, dass du genau diese Angaben für diesen Zweck freigibst.";
  return e;
}

export const hasErrors = (e) => Object.keys(e).length > 0;
